// Writes your routes here

// beneficiary account management
export const beneficiaryStoreApi = 'payment-management/beneficiary/store'
export const beneficiaryListApi = 'payment-management/beneficiary/list'
export const beneficiaryAccountApi = 'payment-management/beneficiary/account'
export const beneficiaryAccountUpdateApi = 'payment-management/beneficiary/account-update'
export const beneficiaryMoveOnlineApi = 'payment-management/beneficiary/move-online'
// payment dashboard
export const paymentDashboardApi = 'payment-management/dashboard/payment-dashboard'
export const onlinePaymentApi = '/grant-panel/online-payment/list'
export const onlinePaymentStoreApi = '/grant-panel/online-payment/store'
export const onlinePaymentCheckBudgetApi = '/grant-panel/online-payment/check-budget'
export const benificiaryData = '/payment-management/beneficiary/account'

// medicale Treatment
export const medTreatEftListApi = 'payment-management/medicale-treatment/eft'
export const medTreatEftApprovalApi = 'payment-management/medicale-treatment/eft-approval'

// private Orphanage
export const privateOrphanageEftListApi = 'payment-management/private-orphanage/eft'
export const privateOrphanageEftApprovalApi = 'payment-management/private-orphanage/eft-approval'

// RG Voluntary
export const rgVoluntaryEftListApi = 'payment-management/rg-voluntary/eft'
export const rgVoluntaryEftApprovalApi = 'payment-management/rg-voluntary/eft-approval'
// natLevelEftListApi
export const natLevelEftListApi = 'payment-management/nat-level/eft'
export const natLevelEftApprovalApi = 'payment-management/nat-level/eft-approval'

// Patient Welfare Assoc
export const patientWelfareAssocEftListApi = 'payment-management/patient-welfare-assoc/eft'
export const patientWelfareAssocEftApprovalApi = 'payment-management/patient-welfare-assoc/eft-approval'
